import React from 'react';
import { connect } from 'react-redux';
import ClientRateRequest from '../../components/ClientRateRequest'
import { getQuotes } from './ClientsAction';
import { getInvitationCodes, generateInvitationCode, inviteClient } from './InvitationsActions';
import moment from 'moment';
//let logger = new Logger('ClientContainer.js');


const initialStartDate = moment().subtract(1, "year").format("YYYY-MM-DD");
const initialEndDate = moment().add(1, "day").set("hour", 23).set("minute", 59).set("second", 59).format("YYYY-MM-DD HH:mm:ss");

class ClientRateRequestContainer extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let { dispatchGetQuotes, quotes } = this.props;
        dispatchGetQuotes({
            startDate: initialStartDate,
            endDate: initialEndDate
        }, (err, result) => {

        });
    }

    render() {
        let { dispatchGetQuotes, initialData,quotes} = this.props;
        return <ClientRateRequest 
            dispatchGetQuotes={dispatchGetQuotes} initialData={initialData}
            quotes={quotes}
            initialStartDate={initialStartDate}
            initialEndDate={initialEndDate}
        />;
    }
}

const mapStateToProps = (state) => ({
    quotes: state.clientsQuotes
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchGetQuotes: (parameters, cb) => dispatch(getQuotes(parameters, cb))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientRateRequestContainer);


// WEBPACK FOOTER //
// ./src/containers/Clients/ClientRateRequestsContainer.js